import { render, staticRenderFns } from "./ContentPerformance.vue?vue&type=template&id=68dd34fa&"
import script from "./ContentPerformance.vue?vue&type=script&lang=js&"
export * from "./ContentPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports